/**
 * Capitalizes the first letter of a string.
 * @param {string} str
 * @returns {string}
 */
export const capitalizeFirst = (str) => {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1);
};

// utils/statusBadge
export const getStatusBadgeClass = (status) => {
  if (!status) return "badge bg-secondary"; // default gray
  
  switch (status.toLowerCase()) {
    case "pending":
      return "badge bg-warning text-dark";
    case "accepted":
      return "badge bg-info text-dark";
    case "matched":
      return "badge bg-primary";
    case "completed":
      return "badge bg-secondary"; // or bg-secondary if you want gray
    case "delivered":
      return "badge bg-success";  
    case "rejected":
      return "badge bg-danger";
    default:
      return "badge bg-secondary";
  }
};

// utils/statusBadge
export const getStatusColor = (status) => {
  if (!status) return "#6c757d"; // gray

  switch (status.toLowerCase()) {
    case "pending":
      return "#ffc107"; // warning yellow
    case "accepted":
      return "#0dcaf0"; // info cyan/light blue
    case "matched":
      return "#0d6efd"; // primary blue
    case "completed":
      return "#6c757d"; // secondary gray
    case "delivered":
      return "#198754"; // success green
    case "rejected":
      return "#dc3545"; // danger red
    default:
      return "#6c757d";
  }
};
